// Remote Punch status of the signed-in employee: whether they may punch from
// anywhere today, whether they still have to accept the location notice, and
// the server's current rules (accuracy limit, monitoring mode).
import { useCallback, useEffect, useState } from "react";
import { remotePunchApi } from "../../../components/RemotePunch/remotePunchApi";

export const useRemotePunch = () => {
  const [state, setState] = useState({
    loading: true,
    remote: null,
    monitoring: true,
    accuracyThresholdMeters: null,
  });

  const load = useCallback(async () => {
    try {
      const data = await remotePunchApi.me();
      setState({
        loading: false,
        remote: data?.remote?.active ? data.remote : null,
        monitoring: data?.monitoring !== false,
        accuracyThresholdMeters: Number.isFinite(data?.accuracyThresholdMeters) ? data.accuracyThresholdMeters : null,
      });
    } catch {
      // No answer → behave exactly like before the feature (regular punch rules).
      setState((s) => ({ ...s, loading: false, remote: null }));
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const acceptConsent = useCallback(async () => {
    await remotePunchApi.acceptConsent();
    setState((s) => (s.remote ? { ...s, remote: { ...s.remote, consentRequired: false } } : s));
  }, []);

  return {
    ...state,
    isRemote: Boolean(state.remote),
    consentRequired: Boolean(state.remote?.consentRequired),
    acceptConsent,
    reload: load,
  };
};

export default useRemotePunch;
